/* eslint-disable */

export type Path = number[];

interface GetPathArguments {
  root: Node;
  target: Node;
}

/**
 * @returns the path from the root to the target, or null if the target doesn't belong to the root.
 */
export function getPath({ root, target }: GetPathArguments): Path | null {
  const path: Path = [];
  let current = target;
  while (root !== current) {
    const parent = current.parentElement;
    if (parent === null) {
      return null;
    }
    const childNodes = Array.from(parent.childNodes);

    // eslint-disable-next-line unicorn/no-for-loop
    for (let i = 0; i < childNodes.length; i += 1) {
      const child = childNodes[i];
      if (child === current) {
        path.unshift(i);
      }
    }
    current = parent;
  }
  return path;
}
interface GetNodeArguments {
  root: Node;
  path: Path;
}

/**
 * A depth-first search using the path for a node in the root.
 *
 * @returns the node at the path in the root, or null if the path points to a place that has no node in the tree.
 */
export function getNode({ root, path }: GetNodeArguments): Node | null {
  try {
    let current = root;
    for (const i of path) {
      current = root.childNodes.item(i);
    }
    return current;
  } catch (error) {
    console.debug(error);
    return null;
  }
}

/**
 * The root of a path is represented as an empty array,
 * because we alwasy assume that a root exists if the path
 * is non-null and not undefined.
 */
export const ROOT_PATH = [];
